//#region import libraries
import React, { useEffect, useRef, useState } from "react"
//styled
import { Colors } from "_styles";
import styled from "styled-components";
//icons
import { BiUserX } from "react-icons/bi";
import { IoMdArrowBack } from "react-icons/io";
import { TbUserSearch } from "react-icons/tb";
import { LuSearchX } from "react-icons/lu";
import { IoEyeOutline } from "react-icons/io5";

//redux
import { useDispatch, useSelector } from "react-redux";
import { openPaxContextMenuModal } from "_redux/slices/utils/menu-context";
import { setBookingSearch, selectSetBookingLocationStatus, resetSetBookingLocationFlags } from "_redux/slices/timeline/timeline-data";
import { setSearchedFlight } from "_redux/slices/timeline/flight-information-list";

//custom components
import ActionsModal from "_components/molecules/Modals/actions-modal";
import UpdatePaxLocationModal from "./update-location-modal";
import { setSelectedTaskToView, setViewTask } from "_redux/slices/timeline/selected-task";
import { formatALTPickUpObject } from "_utils/functions";
//#endregion

const MenuList = styled.div`
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 5px 0px lightgray;
    max-width: 150px;
`;

const StyledParagraph = styled.p`
    cursor: pointer;
    color: ${props => (props.color)};
    font-weight: 500;
    margin-left: 18px;
    margin-top: 12px;
    border-radius: 5px;
    width: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
`;


const LocationContextMenu = (props) => {

    //local state
    const [hover, setHover] = useState('none');
    const [showModal, setShowModal] = useState(false)
    const [activeSearch, setActiveSearch] = useState(false)
    const [shouldCloseMenu, setShouldCloseMenu] = useState(false);
    //redux
    const dispatch = useDispatch()
    const setBookingLocationStatus = useSelector(selectSetBookingLocationStatus)


    //#region functions
    const handleMovePax = () => {
        setShowModal(true)
    }
    //getting flight number from pax info
    const handleFindPax = () => {

        const paxName = props.passenger.isALTPickUp ? props.passenger.passengerInformation.title : props.passenger.name
        dispatch(setBookingSearch(paxName))
        setActiveSearch(true);
        // const flightNumber = props?.passenger?.isALTPickUp
        //     ? `${props?.passenger?.flightInformation?.flightNumber}_${props?.passenger?.flightInformation?.departureAirport}_${props?.passenger?.flightInformation?.arrivalAirport}`
        //     : `${props?.passenger?.flightConfirmationDetails?.carrierCode}${props?.passenger?.flightConfirmationDetails?.flightNumber}_${props?.passenger?.flightConfirmationDetails?.origin}_${props?.passenger?.flightConfirmationDetails?.destination}`
        const flightNumber = props?.passenger?.isALTPickUp
            ? props?.passenger?.flightInformation?.flightNumber
            : `${props?.passenger?.flightConfirmationDetails?.carrierCode}${props?.passenger?.flightConfirmationDetails?.flightNumber}`
        dispatch(setSearchedFlight(flightNumber))
    }
    //clear search input in redux
    const handleClearSearch = () => {
        dispatch(setBookingSearch(""))
        setActiveSearch(false)
        dispatch(setSearchedFlight(""))
    }

    //close menu+clear search if was applied
    const handleBack = () => {
        dispatch(openPaxContextMenuModal(false))
        handleClearSearch()
    };
    //reset flags+close modal and menu
    const closeModal = () => {
        dispatch(resetSetBookingLocationFlags());
        setShowModal(false)
        handleBack()
    }

    const heardClick = () => {
        console.log('Mouse clicked on the screen!');
        if (hover === 'none') {
            setShouldCloseMenu(true); // Defer cancel until loading ends
        }
    };
    const handleViewTask = () => {
        dispatch(setViewTask(true));
        if (props.passenger.isALTPickUp) {
            const ALTPickUpTaskFlightNum = props?.passenger?.flightInformation?.flightNumber;
            const tempCarrierCode = ALTPickUpTaskFlightNum?.startsWith("U2")
                ? "U2"
                : ALTPickUpTaskFlightNum?.match(/[A-Z]+/)?.[0];
            const tempFlightNumber = ALTPickUpTaskFlightNum?.startsWith("U2")
                ? ALTPickUpTaskFlightNum?.split("U2")?.[1]
                : ALTPickUpTaskFlightNum?.match(/\d+/)[0];
            console.log(formatALTPickUpObject(props?.passenger, tempCarrierCode, tempFlightNumber, props?.passenger?.flightInformation?.flightTime, ALTPickUpTaskFlightNum), "formatALTPickUpObject");


            dispatch(setSelectedTaskToView(formatALTPickUpObject(props?.passenger, tempCarrierCode, tempFlightNumber, props?.passenger?.flightInformation?.flightTime, ALTPickUpTaskFlightNum)));
        } else {
            dispatch(setSelectedTaskToView(props.passenger));
        }
        handleBack();
    };
    //#endregion

    //#region useEffect

    //close modal in case success
    useEffect(() => {
        if (setBookingLocationStatus === "succeeded") closeModal()
    }, [setBookingLocationStatus])

    //event listener for clicking
    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('click', heardClick);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener('click', heardClick);
        };
    }, []);

    // watch state to close menu
    useEffect(() => {

        if (shouldCloseMenu) {
            closeModal();            //close the menu after complete loading
            setShouldCloseMenu(false); // Reset the flag
        }
    }, [shouldCloseMenu]);
    //#endregion


    return (

        <MenuList onClick={(e) => e.stopPropagation()} >
            <div style={{ display: showModal ? "none" : "" }} >
                <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Move" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>

                    <StyledParagraph onMouseOver={() => setHover("Move")} onMouseLeave={() => { setHover('none') }} color={hover == "Move" ? 'white' : 'gray'} onClick={handleMovePax}>
                        <BiUserX size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Move passenger"}
                    </StyledParagraph>
                </div>
                <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Find" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    {
                        activeSearch ? (
                            <StyledParagraph onMouseOver={() => setHover("Clear")} onMouseLeave={() => { setHover('none') }} color={hover == "Clear" ? 'white' : 'gray'} onClick={handleClearSearch}>
                                <LuSearchX size={20} style={{ marginInlineEnd: "5px" }} />
                                {"Clear search"}
                            </StyledParagraph>

                        ) : (
                            <StyledParagraph onMouseOver={() => setHover("Find")} onMouseLeave={() => { setHover('none') }} color={hover == "Find" ? 'white' : 'gray'} onClick={handleFindPax}>
                                <TbUserSearch size={20} style={{ marginInlineEnd: "5px" }} />
                                {"Find passenger"}
                            </StyledParagraph>
                        )
                    }

                </div>

                {/* View Task */}
                <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === 'view' ? Colors.PRM_LIGHT_BLUE : 'white', borderBottomLeftRadius: 5, borderBottomRightRadius: 5, cursor: 'pointer' }}>
                    <StyledParagraph onMouseOver={() => setHover('view')} onMouseLeave={() => { setHover('none') }} color={hover == 'view' ? 'white' : 'grey'} onClick={handleViewTask}>
                        <IoEyeOutline size={20} style={{ marginInlineEnd: "5px" }} />
                        View
                    </StyledParagraph>
                </div>

                <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === 'cancel' ? Colors.PRM_LIGHT_BLUE : 'white', borderBottomLeftRadius: 5, borderBottomRightRadius: 5, cursor: 'pointer' }}>
                    <StyledParagraph onMouseOver={() => setHover('cancel')} onMouseLeave={() => { setHover('none') }} color={hover == 'cancel' ? 'white' : 'grey'} onClick={handleBack}>
                        <IoMdArrowBack size={20} style={{ marginInlineEnd: "5px" }} />
                        Back
                    </StyledParagraph>
                </div>

            </div>
            {/*update-pax-location*/}
            <ActionsModal
                isTimeline={true}
                show={showModal}
                handleClose={closeModal}
                title="Change PRM Passenger Location"
                subtitle={"Please select a new location for the PRM passenger by clicking on the drop down list under 'New Location'. Once selected, you can click 'Update Location' to change the PRM passenger's location in the airport. If you would like to remove the passenger from all locations click the red 'Remove Passenger' button"}
            >
                <UpdatePaxLocationModal passenger={props.passenger} />
            </ActionsModal>


        </MenuList >
    )
}

export default LocationContextMenu;